import { Box, Button, TextField } from '@mui/material';
import React, { ChangeEvent, ChangeEventHandler, useEffect, useRef, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { ClassicEditor, Bold, Essentials, Italic, Mention, Paragraph, Undo, Heading, ImageToolbar, ImageStyle, ImageUpload, Link, BlockQuote, Table, TableToolbar, MediaEmbed, List, Image } from 'ckeditor5';

import 'ckeditor5/ckeditor5.css';
import '../styles/ckeditor.css'
import axios from 'axios';
import { AddBlog, DeleteBlogImage, UploadBlogImage } from '../services/ApiServices/BlogService';
import BlogEditor from '../components/BlogEditor';


const uploadAdapters = new Map();

class MyUploadAdapter {
    loader: any;
    imageUrl: string;
    constructor( loader:any ) {
        this.loader = loader;
        this.imageUrl = '';
    }

    upload() {
        return this.loader.file
            .then((file: File) => {
                const formData = new FormData();
                formData.append('image', file);

                return UploadBlogImage(formData);
            })
            .then((response: any) => {
                console.log('File uploaded successfully:', response.data);
                this.imageUrl = response.data.url;
                uploadAdapters.set(this.imageUrl, this); 
                return response.data;
            })
            .catch((error: any) => {
                console.error('Error uploading file:', error);
                return Promise.reject('Upload failed');
            });
    }

    abort() {
        if (this.imageUrl) {
            const fileName = this.imageUrl.split('/').pop();
            DeleteBlogImage(fileName)
                .then(response => {
                    console.log('File removed successfully:', response.data);
                    uploadAdapters.delete(this.imageUrl); 
                })
                .catch(error => {
                    console.error('Error removing file:', error);
                });
        }
    }
}

function MyCustomUploadAdapterPlugin( editor: any ) {
    editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader: any ) => {
        // Configure the URL to the upload script in your backend here!
        return new MyUploadAdapter( loader );
    };
}

function AdminCreateBlog({setLoading, id}: any) {
    const [editorContent, setEditorContent] = useState('');
    const [title, setTitle] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const handleEditorChange = (event:any, editor:any) => {
        const data = editor.getData();
        setEditorContent(data);
    };
    const handleFormSubmit = async (event:any) => {
        setLoading(true);
        try {
            const userInfos = await AddBlog({
                userId: id,
                title: title,
                content: editorContent,
                status: "Active",
                createdAt: new Date().toISOString(),
            });
            setLoading(false);
            setErrorMessage("");
            //setOrders(userInfos);
        } catch (error: any){
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            setLoading(false);
        }
    }
    return (
        <Box className="user-info-wrapper mt-5 mb-5" sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 3, maxWidth: 800, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>

            <div style={{ fontSize: "20px" }} className="about-header text-center font-bold">
                <h1>Giới thiệu</h1>
                <div className="underline"></div>
            </div>
            <TextField id="title-basic" label="Title" variant="outlined" value={title} 
                onChange={(e) => setTitle(e.target.value)} />
            <BlogEditor handleEditorChange ={handleEditorChange} />
             <div>
                <h3>Editor Content:</h3>
                <p>{editorContent}</p>
             </div>

             <div className="text-red-500">{errorMessage}</div>
             <Button variant="contained" onClick={handleFormSubmit} color="primary">Submit</Button>
        </Box>
    );
}

export default AdminCreateBlog;
